import request from "../request";
import sysrequest from "../sysrequest";

const api = {
  // 取得歸屬分行.
  get_servicing_branch(data) {
    const obj = {
      url: "/bid/demo_v1/tbb_servicing_branch/batch/",
      method: "post",
      data,
    };
    if (data.isSys) return sysrequest(obj);
    else return request(obj);
  },

  //  /bid/demo_v1/apv_supply/search/
  get_apv_supply(data) {
    const obj = {
      url: "/bid/demo_v1/apv_supply/search/",
      method: "post",
      data,
    };
    if (data.isSys) return sysrequest(obj);
    else return request(obj);
  },

  //  /bid/demo_v1/award_record/search/
  get_award_record(data) {
    const obj = {
      url: "/bid/demo_v1/award_record/search/",
      method: "post",
      data,
    };
    if (data.isSys) return sysrequest(obj);
    else return request(obj);
  },

  //  /bid/demo_v1/brand_prod/search/
  get_brand_prod(data) {
    const obj = {
      url: "/bid/demo_v1/brand_prod/search/",
      method: "post",
      data,
    };
    if (data.isSys) return sysrequest(obj);
    else return request(obj);
  },

  //  /bid/demo_v1/china_fund/search/
  get_china_fund(data) {
    const obj = {
      url: "/bid/demo_v1/china_fund/search/",
      method: "post",
      data,
    };
    if (data.isSys) return sysrequest(obj);
    else return request(obj);
  },

  //  /bid/demo_v1/com_domain/search/
  get_com_domain(data) {
    const obj = {
      url: "/bid/demo_v1/com_domain/search/",
      method: "post",
      data,
    };
    if (data.isSys) return sysrequest(obj);
    else return request(obj);
  },

  //  /bid/demo_v1/com_invest/search/
  get_com_invest(data) {
    const obj = {
      url: "/bid/demo_v1/com_invest/search/",
      method: "post",
      data,
    };
    if (data.isSys) return sysrequest(obj);
    else return request(obj);
  },

  //  /bid/demo_v1/com_invest_china/search/
  get_com_invest_china(data) {
    const obj = {
      url: "/bid/demo_v1/com_invest_china/search/",
      method: "post",
      data,
    };
    if (data.isSys) return sysrequest(obj);
    else return request(obj);
  },

  //  /bid/demo_v1/com_penalty/search/
  get_com_penalty(data) {
    const obj = {
      url: "/bid/demo_v1/com_penalty/search/",
      method: "post",
      data,
    };
    if (data.isSys) return sysrequest(obj);
    else return request(obj);
  },

  // /bid/demo_v1/com_trade/search_comtrade/
  get_com_trade(data) {
    const obj = {
      url: "/bid/demo_v1/com_trade/search_comtrade/",
      method: "post",
      data,
    };
    if (data.isSys) return sysrequest(obj);
    else return request(obj);
  },

  //  /bid/demo_v1/nation_tax/search/
  get_nation_tax(data) {
    const obj = {
      url: "/bid/demo_v1/nation_tax/search/",
      method: "post",
      data,
    };
    if (data.isSys) return sysrequest(obj);
    else return request(obj);
  },

  //  /bid/demo_v1/pro_certify/search/
  get_pro_certify(data) {
    const obj = {
      url: "/bid/demo_v1/pro_certify/search/",
      method: "post",
      data,
    };
    if (data.isSys) return sysrequest(obj);
    else return request(obj);
  },

  //  /bid/demo_v1/reg_fty/search_regftylist/
  get_regftylist(data) {
    const obj = {
      url: "/bid/demo_v1/reg_fty/search_regftylist/",
      method: "post",
      data,
    };
    if (data.isSys) return sysrequest(obj);
    else return request(obj);
  },

  //  /bid/demo_v1/tech_park/search/
  get_tech_park(data) {
    const obj = {
      url: "/bid/demo_v1/tech_park/search/",
      method: "post",
      data,
    };
    if (data.isSys) return sysrequest(obj);
    else return request(obj);
  },

  // 公司概況表
  get_credit_transaction(data) {
    const obj = {
      url: "/bid/demo_v1/credit_transaction/company_profile/",
      method: "post",
      data,
    };
    if (data.isSys) return sysrequest(obj);
    else return request(obj);
  },
};

export default api;
